import { Outlet } from 'react-router-dom';
import { AdminAuthProvider } from '@/admin/contexts/AdminAuthContext';

export default function AdminLayout() {
  return (
    <AdminAuthProvider>
      <Outlet />
    </AdminAuthProvider>
  );
}
